import angular from 'angular';

import styles from './styles.less';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.troubles', [])
	.config(routes)
	.component('troubles', {
		template: template,
		controller: controller,
		controllerAs: 'ctrl',
		// bindings: {
		// 	config: '<',
		// 	status: '<'
		// 	//onUpdate: '&'
		// }
	})
	.name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/troubles.component/index.js
 **/